var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { isFunction, isObject, isString } from 'angular';
import { CaptchaController } from '../controllers/captcha-controller';
import { CountryFormController } from '../controllers/country-form-controller';
var ContactSalesComponentController = (function (_super) {
    __extends(ContactSalesComponentController, _super);
    function ContactSalesComponentController($http, $q, contactSalesConfiguration, vcRecaptchaService) {
        var _this = _super.call(this, vcRecaptchaService, $q) || this;
        _this.$http = $http;
        _this.contactSalesConfiguration = contactSalesConfiguration;
        _this.defaultSegmetType = 'default';
        _this.showReCaptcha = false;
        _this.showSimpleMath = false;
        return _this;
    }
    ContactSalesComponentController.prototype.$onInit = function () {
        var _this = this;
        if (!isString(this.segmentType) || this.segmentType === '') {
            this.segmentType = this.defaultSegmetType;
        }
        this.loading = true;
        this.contactSalesConfiguration
            .get()
            .then(function (configuration) {
            _this.configuration = configuration;
            _this.translation = configuration.translations[_this.segmentType.toLowerCase()];
            if (!isObject(_this.translation) || _this.translation === null) {
                _this.translation = configuration.translations[_this.defaultSegmetType];
            }
            _this.countries = configuration.countries || [];
            _this.headsets = configuration.headsets || [];
            _this.platforms = configuration.platforms || [];
            _this.fields = configuration.fields || {};
            _this.reCaptchaPublicKey = configuration.reCaptchaPublicKey || '';
            _super.prototype.checkGoogleAccessibility.call(_this).then(function () {
                _this.showReCaptcha = true;
            }, function () {
                _this.initSimpleMath();
                _this.showSimpleMath = true;
            });
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    ContactSalesComponentController.prototype.countrySelected = function (selectedCountryId) {
        CountryFormController.prototype.countrySelected.call(this, selectedCountryId);
    };
    ContactSalesComponentController.prototype.headsetsSelected = function (selectedHeadsetId) {
        var headset = this.headsets.filter(function (h) { return h.id === selectedHeadsetId; })[0];
        this.showFreeTrial = headset ? headset.showFreeTrial : false;
    };
    ContactSalesComponentController.prototype.reCaptchaSetResponse = function (response) {
        _super.prototype.reCaptchaSetResponse.call(this, response);
        this.sendData();
    };
    ContactSalesComponentController.prototype.initSimpleMath = function (callback) {
        var _this = this;
        this.$http.get(this.configuration.simpleMathQuestionEndpoint).then(function (response) {
            _this.simpleMathId = response.data.id || '';
            _this.simpleMathQuestion = response.data.question || '';
            _this.simpleMathUserResult = response.data.userResult || null;
            _this.showSimpleMath = true;
            if (isFunction(callback)) {
                callback();
            }
        });
    };
    ContactSalesComponentController.prototype.submitForm = function (submitEvent) {
        submitEvent.preventDefault();
        this.showReCaptcha ? this.vcRecaptchaService.execute(this.reCaptchaWidgetId) : this.sendData();
    };
    ContactSalesComponentController.prototype.sendData = function () {
        var _this = this;
        var captchaModel = _super.prototype.getCaptchaModel.call(this);
        var submitData = {
            captchaModel: captchaModel,
            fieldInputModels: [
                { id: this.fields.firstName.id, value: this.formData.firstName },
                { id: this.fields.lastName.id, value: this.formData.lastName },
                { id: this.fields.company.id, value: this.formData.company },
                { id: this.fields.email.id, value: this.formData.email },
                { id: this.fields.phone.id, value: this.formData.phone },
                { id: this.fields.country.id, value: this.formData.selectedCountry },
                { id: this.fields.state.id, value: this.states.length > 0 ? this.formData.selectedState : null },
                { id: this.fields.headset.id, value: this.formData.selectedHeadset },
                {
                    id: this.fields.freeTrialUnits.id,
                    value: this.showFreeTrial && this.formData.freeTrialUnits ? '1' : '0',
                },
                { id: this.fields.platform.id, value: this.formData.selectedPlatform },
                { id: this.fields.additionalInformation.id, value: this.formData.additionalInformation },
                { id: this.fields.newsLetter.id, value: this.formData.newsLetter ? '1' : '0' },
            ],
        };
        this.loading = true;
        this.$http
            .post(this.configuration.crmApiEndpoint, JSON.stringify(submitData))
            .then(function (response) {
            if (response.data.statusCode === 400) {
                if (response.data.message !== 'SimpleMath') {
                    _this.hideForm = true;
                    _this.showError = true;
                    return;
                }
                if (!_this.showSimpleMath) {
                    _this.vcRecaptchaService.reload(_this.reCaptchaWidgetId);
                    return;
                }
                _this.initSimpleMath(function () {
                    _this.showSimpleMathError = true;
                });
            }
            else {
                _this.hideForm = true;
                _this.showSuccess = true;
            }
        }, function () {
            _this.hideForm = true;
            _this.showError = true;
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    ContactSalesComponentController.$inject = ['$http', '$q', 'contactSalesConfiguration', 'vcRecaptchaService'];
    return ContactSalesComponentController;
}(CaptchaController));
export var ContactSalesComponent = {
    bindings: {
        segmentType: '<?',
    },
    controller: ContactSalesComponentController,
    templateUrl: 'compatibilityguide/ng-templates/feature/forms/contactsales',
};
